const actions = {
	UPDATE_STEP:"UPDATE_STEP",
	updateStep: (payload) => ({
		type: actions.UPDATE_STEP,
		payload
	})
}
export default actions
  